import React, {useEffect, useState, useRef} from 'react';
import {makeStyles} from '@material-ui/styles';
import useMediaQuery from "@material-ui/core/useMediaQuery";
import theme from "../../theme";
import {Container, Typography} from "@material-ui/core";
import Image from 'next/image';
import {useTranslation} from "tools/i18n";

const useStyles = makeStyles(theme => ({
	wrapper: {
		position: 'relative',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '100%',
		minHeight: 500,
		backgroundPosition: 'top center',
		backgroundRepeat: 'no-repeat',
		overflow: 'hidden',
		maxWidth: 'none',
		backgroundColor: '#000000',
		[theme.breakpoints.down('xs')]: {
			flexDirection: 'column',
			minHeight: 0,
			backgroundColor: theme.palette.primary.background
		},
	},
	inner: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '100%',
		maxWidth: theme.maxWidth,
		[theme.breakpoints.down('xs')]: {
			flexDirection: 'column',
			alignItems: 'flex-start'
		}
	},
	textWrapper: {
		position: 'relative',
		zIndex: 10,
		width: '100%',
		maxWidth: 600
	},
	title: {
		padding: '0px 20px',
		color: theme.palette.primary.background,
		fontSize: 48,
		fontFamily: 'Chronicle, "Open Sans", sans-serif',
		textTransform: "uppercase",
		textAlign: 'center',
		[theme.breakpoints.down('xs')]: {
			marginTop: 15,
			fontSize: 24,
			color: '#000',
			textAlign: 'left'
		}
	},
	descriptionWrapper: {
		margin: 0,
		textAlign: 'center',
		[theme.breakpoints.down('xs')]: {
			marginTop: 0,
			padding: '0 20px',
			textAlign: 'left'
		}
	},
	description: {
		position: 'relative',
		marginTop: 5,
		fontSize: 17,
		lineHeight: 1.5,
		fontWeight: 400,
		color: theme.palette.primary.background,
		'&.closed': {
			maxHeight: 74,
			overflow: 'hidden',
		},
		'& p:first-of-type': {
			marginTop: 0
		},
		'& a': {
			color: 'inherit'
		},
		[theme.breakpoints.down('xs')]: {
			fontSize: 15,
			color: '#000',
			textAlign: 'left',
			'&.closed': {
				maskImage: 'linear-gradient(to bottom, black 45%, transparent 100%)',
			}
		}
	},
	readMore: {
		display: 'inline-block',
		marginTop: 5,
		fontSize: 15,
		fontWeight: 600,
		color: theme.palette.primary.background,
		cursor: 'pointer',
		borderBottom: '1px solid #fff',
		[theme.breakpoints.down('xs')]: {
			marginBottom: 20,
			marginTop: 5,
			fontSize: 14,
			color: '#000',
			borderColor: '#000'
		}
	},
	imageWrapper: {
		[theme.breakpoints.up('sm')]: {
			opacity: 0.8
		}
	},
	image: {
		'&.desktop': {
			display: 'none'
		},
		[theme.breakpoints.up('sm')]: {
			'&.desktop': {
				display: 'block'
			},
			'&.mobile': {
				display: 'none'
			}
		}
	}
}), {name: 'categoryHeader'});

export default function CategoryHeader({category}) {
	const classes = useStyles();
	const {t} = useTranslation();
	const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));
	const [descriptionOpen, setDescriptionOpen] = useState(false);
	const [height, setHeight] = useState(0)
  	const ref = useRef(null);

	useEffect(() => {
		setDescriptionOpen(false);
	}, [category]);

	useEffect(() => {
		if(ref?.current?.offsetHeight) {
			setHeight(ref?.current?.offsetHeight);
		}
	}, [ref, category]);

	function getCategoryMedia(isMobile) {
		if (!category.media) {
			return false;
		}

		let mediaProps = {
			src: category.media.url,
			alt: category.translated?.metaTitle || 'Newport Category'
		};

		if (isMobile) {
			return {
				...mediaProps,
				width: category.media.metaData.width,
				height: category.media.metaData.height
			};
		}

		return {
			...mediaProps,
			layout: 'fill',
			objectFit: 'cover'
		};
	}

	return (
		<div className={classes.wrapper}>
			{getCategoryMedia() ? <div className={classes.imageWrapper}>
				<div className={[classes.image, 'desktop'].join(' ')}><Image {...getCategoryMedia()} priority={true} unoptimized/></div>
				<div className={[classes.image, 'mobile'].join(' ')}><Image {...getCategoryMedia(true)} priority={true} unoptimized/></div>
			</div> : ''}

			<Container disableGutters={true}>
				<div className={classes.inner}>
					<div className={classes.textWrapper}>
						<Typography variant="h1" className={classes.title}>{category.translated.name}</Typography>
						{category.translated.description ? <div className={classes.descriptionWrapper}>
							<div className={[classes.description, !descriptionOpen && (!isDesktop ? height > 75 : height > 75) ? 'closed' : ''].join(' ')}>
								<span ref={ref} style={{display: 'block'}} dangerouslySetInnerHTML={{__html: category.translated.description}}/>
							</div>
							{!descriptionOpen && (!isDesktop ? height > 75 : height > 75) ? <span className={classes.readMore} onClick={() => {setDescriptionOpen(true)}}>{t('read-more')}</span> : ''}
						</div> : ''}
					</div>
				</div>
			</Container>
		</div>
	);
}
